import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLanguageCode } from '@triumph/shared';
import Label from 'components/_utility/Label';
import {
  Wrap,
  Title,
  EditButton,
  DetailsWrap,
  Summary,
  Table
} from './YourDetailsSummary.styled';
import { setStep } from 'src/redux/app/actions';
import { getAddressFields, getBikeCondition, getFormData, getSelectedMake, getSelectedModel } from 'src/redux/app/selectors';
import useLabel from 'src/hooks/useLabel';
import useDataLayer from 'src/hooks/useDataLayer';

const FinanceOptionSummary = () => {
  const dispatch = useDispatch();
  const pushToDataLayer = useDataLayer();
  const getLabel = useLabel();
  const selectedMake = useSelector(getSelectedMake);
  const selectedModel = useSelector(getSelectedModel);
  const bikeCondition = useSelector(getBikeCondition);

  const formData = useSelector(getFormData);
  const addressFields = useSelector(getAddressFields);
  const address = addressFields.reduce((prevAddress, addressField, addressFieldIndex) => {
    prevAddress += formData[addressField.id];

    if (addressFieldIndex !== (addressFields.length - 1) && formData[addressField.id]) {
      prevAddress += ', '
    }

    return prevAddress;
  }, '');

  return (
    <Wrap>
      <Title><Label name="yourDetailsLabel"></Label></Title>
      <EditButton onClick={() => {
        dispatch(setStep(1));
        pushToDataLayer('editLink', {
          sectionEdit: getLabel('yourDetailsLabel'),
        });
      }}>
        <Label name="detailsEditText"></Label>
      </EditButton>
      <DetailsWrap>
        <Table
          headerText={getLabel('personalInfoLabel')}
          tableData={[
            {
              term: getLabel('nameLabel'),
              definition: `${formData.firstName} ${formData.lastName}`,
            },
            {
              term: getLabel('addressLabel'),
              definition: address,
            },
            {
              term: getLabel('emailFieldLabel'),
              definition: formData.email,
            },
            {
              term: getLabel('phoneLabel'),
              definition: formData.phone,
            },
          ]}
        />
        {formData.partExchange === 'yes' ? (
          <Table
            headerText={getLabel('partExchangeLabel')}
            tableData={[
              {
                term: getLabel('makeFieldLabel'),
                definition: selectedMake.name,
              },
              {
                term: getLabel('modelFieldLabel'),
                definition: selectedModel.name,
              },
              {
                term: getLabel('mileageFieldLabel'),
                definition: parseInt(formData.mileage, 10).toLocaleString(getLanguageCode()),
              },
              {
                term: getLabel('regLabel'),
                definition: formData.registration,
              },
              {
                term: getLabel('conditionFieldLabel'),
                definition: bikeCondition.value,
              },
            ]}
          />
        ) : null}
      </DetailsWrap>
      <Summary><Label name="summaryClosingText"></Label></Summary>
    </Wrap>
  );
};

export default FinanceOptionSummary;
